import { Box, Text } from '@factorialco/deprecated-design-system'

import CheckIcon from '../_CheckIcon'

interface FeatureItemProps {
  text: string
  isActive: boolean
}

const FeatureItem = ({ text, isActive }: FeatureItemProps) => (
  <Box flexDirection="row" alignItems="flexStart" gap="s12">
    <Box
      background={isActive ? 'olive1000' : 'white'}
      padding="s1"
      borderRadius={{ all: 'abs016' }}
      alignItems="center"
      style={{
        marginTop: '1px',
      }}
      border={{
        all: {
          color: isActive ? 'olive1000' : 'grey800',
          style: 'solid',
          width: 's2',
        },
      }}
    >
      <CheckIcon color="white" />
    </Box>
    <Text.Normal
      size="200"
      weight={isActive ? 'bold' : 'normal'}
      color={isActive ? 'olive1000' : 'grey800'}
    >
      {text}
    </Text.Normal>
  </Box>
)

export default FeatureItem
